import { useEffect, useMemo } from 'react';

import { Select, SelectContent, SelectGroup, SelectItem, SelectTrigger, SelectValue } from '@mesh.ai/rabbit';
import { LabelFieldWrapper } from 'screens/admin/Reviews/ReviewProcessV2Intent/components/LabelFieldWrapper';

import { ENGAGEMENT_SCALE_TYPE_OPTIONS } from '../constants/AddQuestionConstant';
import {
  EngagementQuestionType,
  EngagementScaleType,
  useAddEngagementQuestion,
} from '../slice/AddEngagementQuestion.slice';

type Props = {
  handleQuestionChange: (value: Partial<EngagementQuestionType>) => void;
};

const TYPE_OPTIONS: Array<{
  value: EngagementScaleType;
  label: string;
}> = [
  { value: 'AGREE_DISAGREE', label: 'Agree - Disagree' },
  { value: 'NEVER_ALWAYS', label: 'Never - Always' },
  { value: 'DISSATISFIED_SATISFIED', label: 'Dissatisfied - Satisfied' },
  { value: 'UNLIKELY_LIKELY', label: 'Unlikely - Likely' },
  { value: 'POOR_EXCELLENT', label: 'Poor - Excellent' },
  { value: 'UNIMPORTANT_IMPORTANT', label: 'Unimportant - Important' },
  { value: 'NOT_CONFIDENT_CONFIDENT', label: 'Not confident - Confident' },
  { value: 'EASY_DIFFICULT', label: 'Easy - Difficult' },
  {
    value: 'NO_UNDERSTANDING_FULL_UNDERSTANDING',
    label: 'No understanding - Full understanding',
  },
];

const TemplateDropdown = ({ handleQuestionChange }: Props) => {
  const { maxOptions, answerOptions, scaleType } = useAddEngagementQuestion();

  const selectedScaleType = useMemo(() => {
    // if scale type is null or undefined, find the value from ENGAGEMENT_SCALE_TYPE_OPTIONS object
    // if not then set it to custom
    // if (!scaleType) {
    const scaleTypeKeys = Object.keys(ENGAGEMENT_SCALE_TYPE_OPTIONS) as EngagementScaleType[];
    const scaleTypeKey = scaleTypeKeys.find((key) => {
      // matching every description and score options
      const options = ENGAGEMENT_SCALE_TYPE_OPTIONS[key][maxOptions];

      const normalize = (
        arr: Array<{
          score: number;
          description: string;
        }>
      ) => arr.map(({ score, description }) => ({ score, description }));
      // checking options and answer options are same
      return JSON.stringify(normalize(options)) === JSON.stringify(normalize(answerOptions));
    });
    return scaleTypeKey;
    // }
    // return scaleType;
  }, [answerOptions, maxOptions]);

  useEffect(() => {
    // if scale type is not null, then update the scale type
    if (selectedScaleType !== scaleType) {
      handleQuestionChange({
        scaleType: selectedScaleType,
      });
    }
  }, [selectedScaleType, handleQuestionChange, scaleType]);

  return (
    <LabelFieldWrapper label="Type" gridTemplateColumns="200px 1fr" gridGap={0}>
      <Select
        value={selectedScaleType ?? 'CUSTOM'}
        onValueChange={(value: EngagementScaleType) => {
          handleQuestionChange({
            scaleType: value,
            answerOptions: ENGAGEMENT_SCALE_TYPE_OPTIONS[value][maxOptions],
          });
        }}
      >
        <SelectTrigger style={{ width: '100%', textAlign: 'left' }}>
          <SelectValue />
        </SelectTrigger>
        <SelectContent style={{ maxWidth: '100%' }}>
          <SelectGroup>
            {TYPE_OPTIONS.map(({ value, label }) => (
              <SelectItem key={value} value={value}>
                {label}
              </SelectItem>
            ))}
            {!selectedScaleType && <SelectItem value="CUSTOM">Custom</SelectItem>}
          </SelectGroup>
        </SelectContent>
      </Select>
    </LabelFieldWrapper>
  );
};

export { TemplateDropdown };
